module.exports = __webpack_public_path__ + "img/Hatchback_Back_Side_Left.de39dc8f.svg";